import { render, staticRenderFns } from "./UpdatePurchasability.vue?vue&type=template&id=1d417301&"
import script from "./UpdatePurchasability.vue?vue&type=script&lang=js&"
export * from "./UpdatePurchasability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports